module.exports = __webpack_public_path__ + "static/media/caffe-millano-square.3a65478a.png";